import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Page } from '../Layout/Page/Page';
import { AddIndex } from './Add/AddIndex';
import { Lookup } from './Lookup';
import { CustomerRoutePaths, PathName } from '../../helpers/Routes';

export const CustomerIndex: React.FC = React.memo(() => {
    return (
        <Page>
            <Routes>
                <Route path={PathName(CustomerRoutePaths.Add, '*')} element={<AddIndex />} />
                <Route path={PathName(CustomerRoutePaths.Lookup, '*')} element={<Lookup />} />
                <Route path={'*'} element={<Navigate replace to={'/'} />} />
            </Routes>
        </Page>
    );
});
